// components/NotFound.js
import React from 'react';

const NotFound = () => {
  return (
    <div style={{ padding: '30px', color: 'red' }}>
      <h2>📛 존재하지 않는 화면입니다</h2>
      <p>해당 메뉴에 연결된 화면 파일이 없습니다.</p>
    </div>
  );
};

export default NotFound;
